export default "/app/themes/majeures/build/images/logo.svg?dbc49e02c2a724a8719765ec80149c19";